<div class="c-card">
	<div class="c-content c-content--lg" style="min-height: 340px;">
		<div class="o-grid o-grid--wrap o-grid--center-h">
			<div
				class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-50@sm-and-up o-grid__cell--center-h o-grid__cell--slim">
				<img src="{{vm.imageUrl}}" alt="{{vm.title}}"
					style="min-height: 130px;"
					[ngStyle]="(vm.service === 'PRESCRIPTION_RENEW_REQUEST') && {'max-width': '70%'}">
			</div>
			<div
				class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@sm-and-up o-grid__cell--w-100@md-and-up o-grid__cell--center-h o-grid__cell--slim">
				<p class="c-text c-text--bold c-text--lg u-osb-md"
					[innerHtml]="vm.title"></p>
				<p class="c-text c-text--lines u-osb-md">{{ vm.text }}</p>
				<p class="c-text c-text--lines c-text--s3 u-osb-md"
					*ngIf="vm.notAvailableText">{{ vm.notAvailableText }}</p>
				<a [id]="vm.linkId" [attr.data-testid]="'previsit-service-' + vm.service" [routerLink]="vm.link" [queryParams]="vm.queryParams"
					class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm"
					*ngIf="!vm.notAvailableText"> {{ vm.btnText }} </a>
			</div>
		</div>
	</div>
</div>
